/**
 * Task Manager: a Kanban-style board/list/task extension, modeled on the
 * newsportal admin dashboard's Task Manager (boards -> lists -> tasks ->
 * comments). Needs no native capabilities. Unlike DB Manager, this panel has
 * no sidebar tree — it's a full-page view (see AppContent.js's
 * `activeTab === 'task-manager.panel'` branch and TaskBoardTab.js), matching
 * the reference implementation: one component that shows either a boards
 * grid or an open board, never a sidebar list of boards. Board content
 * (lists/tasks/comments/rich-text descriptions) is read/written directly by
 * TaskBoardTab.js via Tauri invoke() against the task_board_* Rust commands
 * — the guest iframe (entry.js) is a no-op, kept only to satisfy the
 * extension registration contract.
 */
export const taskManagerManifest = {
  schemaVersion: 1,
  id: 'com.apiboo.task-manager',
  name: 'Task Manager',
  version: '0.1.0',
  publisher: 'apiboo',
  entry: 'dist/main.js',
  icon: 'kanban',
  engines: { apibooSdk: '^1.0.0' },
  // HOST-RENDERED, not sandboxed: the panel above is a first-party React
  // component calling Tauri directly, so `permissions: []` means "declares no
  // GUEST capabilities", not "has no access". Settings reads this flag to say
  // that plainly instead of showing an empty permission list that implies a
  // control the user does not have — see EXT-05.
  hostRendered: true,
  permissions: [],
  contributes: {
    activityBar: [
      { id: 'task-manager.activity', title: 'Task Manager', icon: 'kanban', order: { after: 'teams' } },
    ],
    panels: [{ id: 'task-manager.panel', activityBarId: 'task-manager.activity', title: 'Task Manager' }],
    settings: [],
  },
};
